import { Link } from 'react-router-dom';

export default function BrandStory() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="story-heading">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 id="story-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            品牌故事
          </h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">
            从热爱到使命，尾巴漫画网的成长之路
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=cozy%20modern%20reading%20space%20with%20warm%20lighting%2C%20bookshelves%20filled%20with%20colorful%20comics%2C%20comfortable%20reading%20nook%20with%20warm%20ambient%20light%2C%20cozy%20inviting%20atmosphere%2C%20wooden%20furniture%2C%20soft%20textures%2C%20clean%20aesthetic%2C%20editorial%20photography%20style%20with%20warm%20tones&width=800&height=600&seq=about-brand-story&orientation=landscape"
              alt="尾巴漫画网品牌故事 - 舒适阅读空间"
              title="尾巴漫画网 - 品牌故事"
              className="w-full rounded-2xl shadow-sm"
              loading="lazy"
            />
          </div>
          <div>
            <div className="space-y-5">
              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">始于热爱，忠于品质</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  2020年，一群韩漫爱好者因为找不到优质的中文韩漫阅读平台，决定自己动手打造一个。尾巴漫画网就这样诞生了——一个专注于好看的韩国漫画、提供韩漫在线免费阅读的平台。
                </p>
              </div>
              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">我们做什么</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们致力于为用户提供<strong>高清无删减</strong>的韩国漫画内容，采用<strong>下拉式阅读设计</strong>，让每一位读者都能沉浸在精彩的韩漫世界中。从恋爱到奇幻，从动作到悬疑，我们精心挑选每一部作品，确保内容质量。
                </p>
              </div>
              <div>
                <h3 className="font-heading text-xl font-bold text-foreground-900 mb-2">我们的愿景</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  成为中文互联网上<strong>最好的韩漫阅读平台</strong>。我们相信，每一部好漫画都值得被看到，每一位读者都值得拥有最好的阅读体验。尾巴漫画网将持续为大家带来更多优质的韩国漫画。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-2xl p-6 text-center">
            <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-shield-check-line text-2xl text-primary-500"></i>
            </div>
            <h4 className="font-semibold text-foreground-900 mb-1">正版品质</h4>
            <p className="text-xs text-foreground-500">高清画质，精心翻译校对，保证阅读品质</p>
          </div>
          <div className="bg-background-100 rounded-2xl p-6 text-center">
            <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-speed-up-line text-2xl text-accent-500"></i>
            </div>
            <h4 className="font-semibold text-foreground-900 mb-1">极速加载</h4>
            <p className="text-xs text-foreground-500">优化的图片加载技术，下拉式阅读流畅不卡顿</p>
          </div>
          <div className="bg-background-100 rounded-2xl p-6 text-center">
            <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
              <i className="ri-team-line text-2xl text-secondary-500"></i>
            </div>
            <h4 className="font-semibold text-foreground-900 mb-1">用户至上</h4>
            <p className="text-xs text-foreground-500">认真倾听每一位读者的声音，持续优化体验</p>
          </div>
        </div>
      </div>
    </section>
  );
}